import Vue from 'vue';
import * as types from './types';

const mutations = {
  [types.SET_CAMPAIGNS]: (state, payload) => {
    state.campaigns = payload;
  },
  [types.SET_CAMPAIGN_GROUPS]: (state, payload) => {
    state.campaignGroups = payload;
  },
  [types.ADD_CAMPAIGNS]: (state, payload) => {
    state.campaigns.push(payload);
  },
  [types.SET_CAMPAIGN]: (state, payload) => {
    Vue.set(state, 'campaign', payload);
  },
  [types.SET_CAMPAIGN_STATS]: (state, payload) => {
    state.campaignStats = payload;
  },
  [types.SET_ORDER]: (state, payload) => {
    state.order = payload;
  },
  [types.SET_ORDERS]: (state, payload) => {
    state.orders = payload;
  },
  [types.SET_ADVERTISERS]: (state, payload) => {
    state.existingAdvertisers = payload;
  },
  [types.SET_SELECTED_ADVERTISER]: (state, payload) => {
    state.selectedAdvertiser = payload;
  },
  [types.SET_CONTENT_PROVIDER]: (state, payload) => {
    state.contentProviderId = payload;
  },
  [types.SET_CONTENT_PROVIDER_NAME]: (state, payload) => {
    state.contentProviderName = payload;
  },
  [types.SET_IS_LOADING]: (state, payload) => {
    state.isLoading = payload;
  },
  [types.SET_CURRENCIES]: (state, payload) => {
    state.currencies = payload;
  },
  [types.SET_LINKING_WORDS]: (state, payload) => {
    state.linkingWords = payload;
  },
  [types.SET_COUNTRIES]: (state, payload) => {
    state.countries = payload;
  },
  [types.SET_REGIONS]: (state, payload) => {
    state.regions = payload;
    state.regionsMap = new Map(payload.map((i) => ([i.id, i])));
  },
  [types.SET_BLACKLIST]: (state, payload) => {
    state.blacklist = payload;
  },
  [types.SET_PUBLISHER_LIST]: (state, payload) => {
    state.publisherList = payload;
    state.publisherListMap = new Map(payload.map((i) => ([i.id, i])));
  },
  [types.SET_PUBLISHER]: (state, payload) => {
    state.publisherIds.push(payload);
  },
  [types.REMOVE_PUBLISHER]: (state, payload) => {
    state.publisherIds.splice(payload, 1);
  },
  [types.CLEAR_PUBLISHERS]: (state) => {
    state.publisherIds = [];
  },
  [types.SET_PUBLISHER_GROUPS]: (state, payload) => {
    state.selectedPublisherGroups = payload;
  },
  [types.SET_ADX_ADVERTISERS]: (state, payload) => {
    state.adxAdvertisers = payload;
  },
  [types.SET_DEAL_OVERRIDES]: (state, payload) => {
    state.dealOverrides = payload;
  },
  [types.SET_AGENCIES_LIST]: (state, payload) => {
    state.agencies = payload;
  },
  [types.ADD_AGENCY_TO_LIST]: (state, payload) => {
    state.agencies.push(payload);
  },
  [types.SET_VIEW_TYPE]: (state, payload) => {
    state.viewType = payload;
  },
  [types.SET_CAMPAIGN_STATE]: (state, payload) => {
    if (state.campaign?.id !== payload.id) return;
    Vue.set(state.campaign, 'state', payload.state);
  },
  [types.SET_CAMPAIGN_INFO_CHANGES]: (state, payload) => {
    if (Object.keys(payload).length === 0) {
      state.orderChanges = {};
      state.campaignChanges = {};
      return;
    }
    const { target, property, value } = payload;
    const stateVariable = state[`${target}Changes`];
    if (stateVariable.hasOwnProperty([property]) && value === null) return Vue.delete(stateVariable, property);
    if (value) Vue.set(stateVariable, property, value);
  },
  [types.SET_CAMPAIGN_PROPERTIES]: (state, payload) => {
    state.campaignProperties = payload;
  },
  [types.SET_CAMPAIGN_LOGO]: (state, payload) => {
    Vue.set(state.campaignProperties, 'logo', payload);
  },
  [types.SET_CAMPAIGN_STATES]: (state, payload) => {
    state.campaignStates = payload;
  },
  [types.CLEAR_CAMPAIGN_TEMPLATE_GROUP]: (state) => {
    Vue.set(state.campaign, 'templateGroupId', null);
  },
  [types.DELETE_CAMPAIGN_LOGO]: (state) => {
    Vue.delete(state.campaignProperties, 'logo');
  },
  [types.ADD_OR_UPDATE_CAMPAIGN_PERMISSIONS]: (state, payload) => {
    state.permissions.set(payload.campaignId, {
      ownerAccess: payload.ownerAccess,
      sharedTypes: payload.shareTypes ? payload.shareTypes : [],
    });
  },
  [types.SET_GEO_LOCATIONS]: (state, payload) => {
    state.geoLocations = payload;
  },
};

export default mutations;
